import { render, staticRenderFns } from "./NewConfiguration.vue?vue&type=template&id=241e7cde&"
import script from "./NewConfiguration.vue?vue&type=script&lang=js&"
export * from "./NewConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./NewConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports